<template>
    <div class="content">
        <div class="icon-close">
            <img src="/img/close-menu.png" class="p-3" @click="closeSidebar"/>
        </div>
        <div class="text-center menu-content d-flex justify-content-between">
                <div>
                    <a
                        v-if="!isEcommercePlatform"
                        class="p4b c14 d-block link-item has-badge"
                        href="https://ecommerce.crossprom.com/"
                        target="_blank"
                        @click="toEcommerce">
                        E-commerce<span></span>
                    </a>
                    <router-link
                        class="p4b c14 d-block link-item"
                        @click.native="toHomepage"
                        to="/">
                        Home
                    </router-link>
                    <a
                        class="p4b c14 d-block link-item"
                        href="https://help.crossprom.com/"
                        target="_blank"
                        @click="toCrosspromHelp">
                        Help
                    </a>
                    <!-- <router-link
                        class="p4b link-item d-block"
                        to="/pricing"
                        @click.native="toPricing">
                        Pricing
                    </router-link> -->
                    <button id="login-button-header" class="mx-auto text-center login p4b link-item d-block" @click="showModal('login')">
                        Login
                    </button>
                </div>
                <div>
                    <p class="blured-text">
                        Boost Your Campaign <br/> 
                        With The Power of the <br/>
                        Crowdfunding Community
                    </p>
                    <Button class="d-block mx-auto priceStartNow pric-btn purple-on-hover" id="signup-button-header" @click.native="showModal('sign-up')">
                        Sign up
                    </Button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Button from '../components/Theme/Button'
export default {
    name: 'SideMenu',
     computed: {
        ...mapState([
            'user'
        ]),
        ...mapGetters([
            'isEcommercePlatform'
        ])
    },
    components: {
        Button
    },
    methods: {
        closeSidebar(){
            this.$emit('hide')
        },
        toHomepage(){
            this.closeSidebar()
        },
        toEcommerce(){
            this.$sendMixpanelEvent('Ecommerce Link Clicked', {
                'Link Location': 'Navbar Mobile',
                'LoggedIn': !!this.user
            });

            this.$ga.event('Ecommerce Clicked', 'Click', `
                Link Location: Navbar Mobile,
                LoggedIn: ${!!this.user}
            `)
        },
        toPricing(){
            this.closeSidebar()
            this.$sendMixpanelEvent('Pricing Page Opened', {
                'Opened From': 'Navbar Pricing Link',
                'Logged In': false
            });

            this.$ga.event('Pricing', 'Pricing Page Opened',`
                OpenedFrom:Navbar Pricing Link,
                LoggedIn:false
            `);
        },
        showModal(modalName, actionName){
            this.closeSidebar()
            this.$store.dispatch('clearErrors');
            if(this.user && this.user.uid) {
                this.$router.push('/browse')
                return
            }
            this.$store.commit('TOGGLE_MODAL', [modalName, {
                openedFrom: 'Navbar',
                chosenPlanOnSignup: modalName === 'sign-up' ? {name: 'basic'} : null
            }]);
        }, 
        toCrosspromHelp(){
            this.$ga.event('Help', 'Click', `
                LoggedIn: false,
                Location: Navbar
            `)
            this.$sendMixpanelEvent('Help Clicked', {
                'Logged In': false,
                'Link Location': 'Navbar'
            });
        },
    }
}
</script>


<style lang="scss">
@import '../assets/scss/variables';
.content {
    background-color: $c1;
    width: 85%;
    height: 100%;
    box-shadow: 0 0 10px 3px rgba(0,0,0,0.3);

    .menu-content {
        margin-top: 32px;
        flex-direction: column;
        height: 60%;
    }

    .icon-close {
        text-align: right;
        padding-right: 5px;
        padding-top: 4px;
        cursor: pointer;
    }

    .link-item {
        color: $c14;
        padding: 5px;
        margin-bottom: 24px;
    }
    .blured-text {
        margin-top: 10px;
        margin-bottom: 24px;
        font-weight: 600;
        font-size: 19px;
        line-height: 25px;
        text-align: center;
        color: #FFFFFF;
        opacity: 0.5;
    }

    .pric-btn {
        max-width: 268px;
        width: 90%;
        padding: 18px 10px;
    }

    .has-badge {
        display: flex;
        position: relative;
        span {
            display: flex;
            position: absolute;
            background: #FFFFFF;
            border-radius: 2px;
            color: #727CF5;
            display: inline-block;
            padding: 0px 2px;
            width: 23px;
            height: 11px;
            left: calc(50% + 70px);
            top: 0;
            margin-left: 2px;

            &::after {
                content: 'new';
                position: absolute;
                display: inline-block;
                font-size: 9px;
                line-height: 9px;
                left: 2px;
            }
        }
    }
}
</style>